import {MUTATION_KEYS} from '@/queryClient.ts'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types'
import {httpChangePassword} from './account.http'

type UseChangePasswordOptions = {
    onSuccess?: () => void
    onError?: (error: AxiosError<ErrorResponseData>) => void
}

export const useChangePassword = (options?: UseChangePasswordOptions) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.RESET_PASSWORD],
        mutationFn: httpChangePassword,
        onError: (error: AxiosError<ErrorResponseData>) => options?.onError?.(error),
        onSuccess: () => options?.onSuccess?.()
    })
